import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = Array<[number, Array<[string, number | undefined]>]>;

export default function HotnTables({ tables }: { tables: { loot: Tables } }) {
  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Loot Subscription"} />
        <h2 className="h2 p-4 pb-8 flex items-center gap-1">
          {T.common("TFT_Portals_Unique_LootSubscription")}
        </h2>
        <LootGrid data={tables.loot.map(([odds, vs]) => [odds, vs])} />
      </div>
    </AdLayout>
  );
}
